import { render, staticRenderFns } from "./attach-user.vue?vue&type=template&id=7cc59252&scoped=true&"
import script from "./attach-user.vue?vue&type=script&lang=js&"
export * from "./attach-user.vue?vue&type=script&lang=js&"
import style0 from "./attach-user.vue?vue&type=style&index=0&id=7cc59252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc59252",
  null
  
)

export default component.exports